/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
const ContactView = () => import('./ContactView');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/contact-views'),
      name: 'home_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/contact-views/:contact_id'),
      name: 'inbox_contact_views_conversation',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => {
        return { inboxId: 0, contactId: route.params.contact_id };
      },
    },
    {
      path: frontendURL('accounts/:accountId/inbox-contact-views/:inbox_id'),
      name: 'inbox_dashboard_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => {
        return { inboxId: route.params.inbox_id };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/inbox-contact-views/:inbox_id/contact-views/:contact_id'
      ),
      name: 'conversation_through_inbox_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => {
        return {
          contactId: route.params.contact_id,
          inboxId: route.params.inbox_id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/label-contact-views/:label'),
      name: 'label_contacts_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({ label: route.params.label }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/label-contact-views/:label/contact-views/:contact_id'
      ),
      name: 'conversations_through_label_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        contactId: route.params.contact_id,
        label: route.params.label,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/team-contact-views/:teamId'),
      name: 'team_contacts_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({ teamId: route.params.teamId }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/team-contact-views/:teamId/contact-views/:conversationId'
      ),
      name: 'conversations_through_team_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        conversationId: route.params.conversationId,
        teamId: route.params.teamId,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/custom_contacts_view/:id'),
      name: 'folder_contacts_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({ foldersId: route.params.id }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/custom_contacts_view/:id/contact-views/:contact_id'
      ),
      name: 'conversations_through_folders_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        contactId: route.params.contact_id,
        foldersId: route.params.id,
      }),
    },
    {
      path: frontendURL('accounts/:accountId/mentions/contact-views'),
      name: 'conversation_mentions_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: () => ({ conversationType: 'mention' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/mentions/contact-views/:conversationId'
      ),
      name: 'conversation_through_mentions_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'mention',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/unattended/contact-views'),
      name: 'conversation_unattended_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: () => ({ conversationType: 'unattended' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/unattended/contact-views/:conversationId'
      ),
      name: 'conversation_through_unattended_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'unattended',
      }),
    },
    {
      path: frontendURL('accounts/:accountId/participating/conversations'),
      name: 'conversation_participating_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: () => ({ conversationType: 'participating' }),
    },
    {
      path: frontendURL(
        'accounts/:accountId/participating/contact-views/:conversationId'
      ),
      name: 'conversation_through_participating_contact_views',
      roles: ['administrator', 'agent'],
      component: ContactView,
      props: route => ({
        conversationId: route.params.conversationId,
        conversationType: 'participating',
      }),
    },
  ],
};
